import './communities.css';
import AppLayoutFrame from './components/AppLayoutFrame';
import LoadingApp from './components/UI/LoadingApp';
import UserPreferences from './components/UserPreferences';
import './crm.css';
import './general.css';
import './index.css';
import './NewLook.css';
import './app.less';
import { ScrollerConfigProvider } from './components/UI/Scroller/ScrollerConfigContext';
import UserDataStore from './components/User/containers/UserDataStore';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from './AppInsights';
import ReactGA from 'react-ga';
import { QueryClientProvider, QueryClient } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import CacheKeysEnum from './CacheKeysEnum';

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 1000 * 60, // globally default to 1 minute
		},
	},
});

queryClient.setQueryDefaults(CacheKeysEnum.SkusAvailableInWebReader, {
	staleTime: 1000 * 1800,
});

export default function App() {
	ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_CODE);
	window.FreshworksWidget('hide', 'launcher');
	return (
		<div className="app">
			<AppInsightsContext.Provider value={reactPlugin}>
				<QueryClientProvider client={queryClient}>
					<UserDataStore>
						{userDataStore => (
							<UserPreferences>
								<ScrollerConfigProvider>
									{userDataStore.isLoading() ? (
										<LoadingApp />
									) : (
										<AppLayoutFrame />
									)}
								</ScrollerConfigProvider>
							</UserPreferences>
						)}
					</UserDataStore>
					<ReactQueryDevtools initialIsOpen={false} />
				</QueryClientProvider>
			</AppInsightsContext.Provider>
		</div>
	);
}
